export default __webpack_public_path__ + "static/media/check2.6a5fb8bd.svg";